import React from 'react';
import './top-footer.scss';

function TopFooter() {
  return (
    <div className='TopFooter'>
      <div className='support'>
        <h3>Hai bisogno di assistenza?</h3>
        <p>Puoi chiamarci ogni giorno dalle 7:00 alle 20:00 o inviarci una mail per informazioni e supporto sul Wi-Fi My Lotteries</p>
      </div>

      <div className='contact-us'>
        <div className='phone-number'>
          <p>Chiamaci al:</p>
          <h3><a href="tel:800 929394">800 929394</a></h3>
        </div>

        <div className='email'>
          <p>Scrivici a:</p>
          <h3><a href="mailto:info@mylotteries.it">info@mylotteries.it</a></h3>
        </div>
      </div>
    </div>
  );
}

export default TopFooter;
